import _ from 'lodash';
import { AppError } from '@or-sdk/hitl';

import { useOnlineStatus } from './use-online-tracker';
import { UIEventBus, SHOW_NOTIFICATION_TOAST } from '@/common/ui-event-bus';

export interface IApiError {
  readonly cause: () => Record<string, string> | Record<string, string>;
}

export const useErrorHandling = () => {
  const { isOnline } = useOnlineStatus();

  /* TODO: remove after we replace @onereach/sdk with @or-sdk */
  const getAPIErrorDetails = (error: IApiError) => {
    const cause = _.isFunction(error.cause) ? error.cause() : error.cause;
    const response = _.pick(cause, [
      'response.status',
      'response.data',
      'response.config.baseURL',
      'response.config.url',
      'response.config.method',
      'response.config.data',
      'response.config.params',
    ]);

    return _.get(response, 'response', {});
  };

  /** Handle errors thrown by current or old OR SDK */
  const handleSDKError = (args: {
    error: Error | AppError | IApiError;
    options?: { showToast?: boolean; };
  }) => {
    const { error, options = { showToast: true } } = args;
    /* Don't show errors while offline screen is visible */
    if (!options.showToast || !isOnline.value) {
      return;
    }

    let errorDetails = {};
    if (error instanceof AppError) {
      errorDetails = error.detailsToObject();
    } else if ('cause' in error) {
      errorDetails = getAPIErrorDetails(error);
    }

    const details = {
      timestamp: new Date(),
      ...errorDetails,
    };
    const toast = { message: error, type: 'ERROR', details };
    UIEventBus.$emit(SHOW_NOTIFICATION_TOAST, toast);
  };

  return { handleSDKError };
};
